<div class="item-grid-container shadow">
  <div class="sales-summary-holder">
    <div class="search-holder">
      <ul class="list-inline grid-top-actions w-90 mb-3">
        <!--<li class="list-inline-item">
          <p class="mb-2 mx-2">{{'pages.Creditlinereport.From' | translate }}</p>
        </li>
        <li class="list-inline-item">
          <div class="calendar-btn">
            <input
              matInput
              [matDatepicker]="dpFrom"
              disabled
              [min]="minFromDate"
              placeholder="MM/DD/YYYY"
              [max]="maxDate"
              (dateChange)="changeFromDate($event)"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="dpFrom"
            ></mat-datepicker-toggle>
            <mat-datepicker #dpFrom disabled="false"></mat-datepicker>
          </div>
        </li>
        <li class="list-inline-item">
          <p class="mb-2 mx-2">{{'pages.Creditlinereport.To' | translate }}</p>
        </li>
        <li class="list-inline-item">
          <div class="calendar-btn">
            <input
              matInput
              [matDatepicker]="dpTo"
              disabled
              [min]="minToDate"
              placeholder="MM/DD/YYYY"
              [max]="maxDate"
              (dateChange)="changeToDate($event)"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="dpTo"
            ></mat-datepicker-toggle>
            <mat-datepicker #dpTo disabled="false"></mat-datepicker>
          </div>
        </li>-->
        <li class="list-inline-item ">
          <div class="search-holder">
            <input
              type="text"
              placeholder="{{ 'pages.newRetailer.search' | translate }}"
              matInput
              class="
                rounded-pill
                px-3
                py-2
                mb-0
                border-0
                bg-light
                w-100
                me-0
                input-search
                ms-3
              "
              (keyup)="quickSearch()"
              [(ngModel)]="searchValue"
            />
            <i
              color="primary"
              class="search-icon-holder"
              matSuffix
              mat-icon-button
              aria-label="Search"
            >
              <mat-icon>search</mat-icon>
            </i>
          </div>
        </li>
        <!-- <li class="list-inline-item">
                  <h4 class="transaction-dates">{{transactionFromDate}} - {{transactionToDate}}</h4>
                </li> -->
        <li class="list-inline-item float-end">
          <button
          [disabled]="isButtonDisabled"
            mat-stroked-button
            color="primary"
            class=""
            (click)="exportData()"
          >
            <span translate class="translate">pages.newRetailer.download</span>
            <i class="mi mi-save-alt"></i>
          </button>
        </li>
      </ul>
    </div>
    <hr />
    <div class="stats-blks-holder">
      <div class="row" [ngStyle]="{'display': userRole === 'Super Admin' ? 'block' : 'none'}">
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
          <div
            class="sales-card card border-0 py-3 px-2 rounded bg-theme-light"
          >
            <h5>
              {{ 'pages.SaleSummary.TotalSalesThisYear' | translate}} <br />
              <span class="values"
                >{{ this.summary?.totalSales | currency }}
              </span>
            </h5>
          </div>
        </div>
      </div>
    </div>
    <hr class="mb-0" />
    <div class="realtime-transactions-grid-container">
      <ag-grid-angular
        style="width: 100%; height: 60vh"
        class="ag-theme-material"
        [rowHeight]="40"
        [enableFilter]="true"
        [enableSorting]="true"
        [enableColResize]="true"
        [columnDefs]="columnDefs"
        [rowData]="rowData"
        (gridReady)="onGridReady($event)"
        (selectionChanged)="onSelectionChanged($event)"
        (firstDataRendered)="headerHeightSetter($event)"
        (columnResized)="headerHeightSetter($event)"
        [enableRangeSelection]="true"
      >
      </ag-grid-angular>
    </div>
  </div>
</div>
